import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withPreloading, NoPreloading } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { TimeagoModule } from 'ngx-timeago';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar-portable';
import { TimeAgoPipe, GroupByPipe } from 'ngx-pipes';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';

import { AppComponent } from '@app/app.component';
import { routes } from '@app/app.routes';
import { MaterialModule } from '@app/material.module';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared/shared.module';
import { ShellModule } from '@app/shell/shell.module';
import { HomeModule } from '@app/home/home.module';
import { AuthModule } from '@app/auth/auth.module';
import { ProfileModule } from '@app/profile-feature/profile.module';
import { environment } from '@env/environment';
import { hmrBootstrap } from './hmr';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { Chart, registerables } from 'chart.js';
import * as moment from 'moment';

moment.locale('en');
Chart.register(...registerables);

// Factory function for TranslateHttpLoader
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = () => {};
  }
}

const bootstrap = () =>
  bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(routes, withPreloading(NoPreloading)),
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimations(),
      provideServiceWorker('ngsw-worker.js', { enabled: environment.production }),
      provideCharts(withDefaultRegisterables()),
      provideTranslateService({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
      TimeAgoPipe,
      GroupByPipe,
      ToArabicPipe,
      importProvidersFrom(
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forRoot(), // pipes/directives only — service comes from provideTranslateService above
        MaterialModule,
        CoreModule,
        SharedModule,
        ShellModule,
        HomeModule,
        AuthModule,
        ProfileModule,
        FlexLayoutModule,
        ToastrModule.forRoot({
          positionClass: 'toast-top-left'
        }),
        TimeagoModule.forRoot(),
        PerfectScrollbarModule
      )
    ]
  });

if (environment.hmr) {
  hmrBootstrap(module, bootstrap);
} else {
  bootstrap().catch(err => console.error(err));
}
